"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getPercentage = (price, originalPrice) => Math.ceil((originalPrice - price) / originalPrice * 100);
var _default = exports.default = getPercentage;